import { gql } from '@apollo/client';

export const CTA_ONBOARDING_STATE = gql`
  query CtaOnboardingState($documentId: UUID!) {
    ctaOnboardingState(documentId: $documentId) {
      documentId
      extractionStatus
      studyId
      studyName
      ssiId
      sponsorOrgId
      croOrgId
      ratesCount
      contractTermsConfirmed
    }
  }
`;

export const CTA_EXTRACTION_PREVIEW = gql`
  query CtaExtractionPreview($documentId: UUID!) {
    ctaExtractionPreview(documentId: $documentId) {
      extractionStatus
      protocolId
      sponsorName
      croName
      piName
      piNpi
      piFirstName
      piLastName
      piSuffix
      piCredential
      siteAddress
      effectiveDate
      endDate
      rateSchedule {
        itemName
        category
        amountMicros
        currencyCode
        paymentType
        frequency
        overheadExempt
        notes
        confidence
      }
      overheadPercentage
      withholdingPercentage
      withholdingTerms
      contractTerms
      confidenceScore
      visitSchedule {
        visitName
        visitNumber
        phase
      }
      budgetMatrixPhases {
        phaseName
        visits
        procedureEntries {
          procedureName
          visitName
          count
          occurrenceType
        }
      }
      matchedStudy {
        id
        protocolId
        name
        primaryAlias
      }
      matchedPhysician {
        id
        npi
        firstName
        lastName
        suffix
        credential
        primarySpecialty
        combinedScore
      }
    }
  }
`;
